import { Gamepad2, ArrowRight, Radio, Trophy, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

const GamingHome = () => {
  return (
    <section
      id="gaming-home"
      data-testid="home-gaming-block"
      className="relative overflow-hidden bg-slate-950 py-20 text-white"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-0 top-0 h-80 w-80 rounded-full bg-sky-500/25 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-96 w-96 rounded-full bg-pink-500/25 blur-3xl" />
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.06) 1px, transparent 1px), radial-gradient(circle at 80% 60%, rgba(255,255,255,0.06) 1px, transparent 1px)",
            backgroundSize: "40px 40px, 60px 60px",
          }}
        />
      </div>

      <div className="relative mx-auto grid max-w-7xl gap-10 px-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-pink-300/30 bg-pink-500/10 px-3 py-1 text-[11px] font-black uppercase tracking-[0.3em] text-pink-200 backdrop-blur">
            <Gamepad2 className="h-3.5 w-3.5" /> Nueva vertical
          </div>
          <h2 className="mt-5 text-4xl font-black leading-[1.05] tracking-tight md:text-6xl">
            <span className="bg-gradient-to-r from-sky-300 via-white to-pink-300 bg-clip-text text-transparent">
              Silicomlan Gaming
            </span>
          </h2>
          <p className="mt-3 text-sm font-bold uppercase tracking-[0.3em] text-sky-300">
            La red también se juega.
          </p>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-200 md:text-lg">
            Jugás, competís, hacés streaming o creás contenido. Descubrí una
            nueva vertical de Silicomlan para quienes viven la conexión de otra
            manera.
          </p>

          <div className="mt-7 flex flex-wrap gap-2">
            {[
              { icon: Trophy, label: "Torneos" },
              { icon: Users, label: "Comunidad" },
              { icon: Radio, label: "Streaming" },
              { icon: Gamepad2, label: "Competencias" },
            ].map(({ icon: Icon, label }) => (
              <span
                key={label}
                className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-widest text-white/85 backdrop-blur"
              >
                <Icon className="h-3.5 w-3.5 text-sky-300" /> {label}
              </span>
            ))}
          </div>

          <div className="mt-8">
            <Button
              asChild
              data-testid="home-gaming-cta"
              className="group rounded-full bg-gradient-to-r from-pink-500 to-rose-500 px-7 py-6 text-sm font-black uppercase tracking-widest text-white shadow-[0_0_32px_rgba(236,72,153,0.35)] hover:from-pink-600 hover:to-rose-600"
            >
              <a href="/gaming">
                Conocé Silicomlan Gaming
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
            </Button>
          </div>
        </div>

        <div className="relative">
          <div className="relative rounded-3xl border border-white/10 bg-gradient-to-br from-slate-900/90 to-slate-950/90 p-6 shadow-[0_20px_60px_rgba(0,0,0,0.5)] backdrop-blur">
            <div className="flex items-center justify-between">
              <span className="rounded-full border border-sky-300/30 bg-sky-400/10 px-3 py-1 text-[10px] font-black uppercase tracking-[0.3em] text-sky-200">
                Vertical Gaming
              </span>
              <span className="flex h-2.5 w-2.5 items-center">
                <span className="absolute h-2.5 w-2.5 animate-ping rounded-full bg-pink-400/60" />
                <span className="relative h-2.5 w-2.5 rounded-full bg-pink-400" />
              </span>
            </div>
            <p className="mt-6 text-4xl font-black leading-tight md:text-5xl">
              Jugá.{" "}
              <span className="bg-gradient-to-r from-pink-300 to-sky-300 bg-clip-text text-transparent">
                Competí.
              </span>{" "}
              Streameá.
            </p>
            <p className="mt-4 text-sm text-slate-300">
              Detrás de cada partida, cada directo y cada clip hay algo que no se
              ve: la red.
            </p>
            <div className="mt-6 grid grid-cols-3 gap-3 text-center">
              {["FTTH", "Baja latencia", "Red propia"].map((item) => (
                <div
                  key={item}
                  className="rounded-xl border border-white/10 bg-white/5 py-3 text-[10px] font-bold uppercase tracking-widest text-white/85"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
          <div className="pointer-events-none absolute -bottom-5 -right-5 h-32 w-32 rounded-full bg-pink-500/20 blur-2xl" />
          <div className="pointer-events-none absolute -top-5 -left-5 h-32 w-32 rounded-full bg-sky-500/20 blur-2xl" />
        </div>
      </div>
    </section>
  );
};

export default GamingHome;
